import { Component, OnInit,Input,EventEmitter,Output,ViewChild} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { Subject } from 'rxjs';
import { Router,ActivatedRoute } from '@angular/router';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import { SessionService } from 'src/app/Services/session.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;

@Component({
  selector: 'app-question-status-report',
  templateUrl: './question-status-report.component.html',
  styleUrls: ['./question-status-report.component.css']
})
export class QuestionStatusReportComponent implements OnInit {
  QuestionStatusReport:any;
  Question:any;
  constructor(private toastr: ToastrService,public session:SessionService,public service:QuestionManagementService,public Activeroute:ActivatedRoute,public route:Router) { }

  ngOnInit(): void {
    this.getsubject(null,null);
  }
  GetQuestionStatusReport(subject:number){
   
  }

  selectedsubject:any;
  selectsubject(data:any){
    
    this.service.SelectSubject=data.target.value;
    this.selectedsubject=data.target.value;
    this.service.GetQuestionReportWithStatus({'LoggedInUser':this.session.getUser(),'SubjectID':this.selectedsubject,'Question_Status_Type_Code':'Defer'}).subscribe((i:any)=>{
      this.Question=i;
      if(this.Question.Message=='Success'){
      this.QuestionStatusReport=this.Question.Data;
      console.log(this.QuestionStatusReport,'QuestionStatusReport');
      }
      else{
        this.toastr.error(this.Question.Message);
      }

}, error => {  console.log(error) }
);
   
  }
  subject:any;
  getsubject(data:any,d:any){
    let ID:Number=0;
    if(data !=null){ID=Number(data.ID);}
    let list: any = {};
    list["currentNodeID"] = ID;
    list["screenName"] = 'SUBJECT BREAKDOWN';
    list["childRecordStatus"] = 'ALL';
    list["CalledFrom"] = 'Question';
    this.service.getSubjectTree(list).subscribe((i:any)=>{
      this.subject=i;
      console.log(this.subject);
     
  }, error => {  console.log(error) 
    
  }
  );
  }

}
